export function IconShield({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      focusable="false"
      aria-hidden="true"
    >
      {/* Schild-Outline: oben gerade Schulter, unten zu Spitze gerundet */}
      <path d="M12 3 L20 6 V12 C20 16.5 16.5 20 12 21 C7.5 20 4 16.5 4 12 V6 Z" />
      {/* Haekchen innen: kommuniziert geprueft / abgesichert */}
      <path d="M9 12 L11 14 L15.5 9.5" />
    </svg>
  );
}
